<template>
    <div v-show="largeModal" style="font-family: Hind Siliguri Light " class="modal-window">
        <div class="modal-content">
            <div style="border-bottom:1px solid #bbc3ca" class="container">
                <div class="row">
                    <div class="col-md-6">
                        <span class="pull-left"><b>লিজের আবেদন ফরম</b></span>
                    </div>
                    <div class="col-md-6">
                        <span @click="close()" style="cursor:pointer" class="pull-right"><b><i class="fa fa-times"></i></b></span>
                    </div>
                </div>
                <div style="width:100%;height:10px;"></div>
            </div>
            <div class="container pt-2">

            <form @submit.prevent="addApplication">
                <div class="container custom_modal_body">
                <div  class="form-group row">
                    <label  class="col-sm-3 col-form-label">মোবাইল নম্বর</label>
                    <div class="col-sm-3">
                        <input type="text" disabled v-validate="'required|numeric'" v-model="user.mobile_number" class="form-control" name="phone" placeholder="মোবাইল নম্বর">
                    </div>
                    <label  class="col-sm-3 col-form-label">এন.আই.ডি নম্বর</label>
                    <div class="col-sm-3">
                        <input type="text" disabled v-validate="'required|numeric'" v-model="user.nid" class="form-control" name="nid" placeholder="এন.আই.ডি নম্বর">
                    </div>
                </div>
                <div  class="form-group row">
                    <label  class="col-sm-3 col-form-label"> নাম</label>
                    <div class="col-sm-3">
                        <input name="name" disabled v-validate="'required'"   type="text"  v-model="user.name" class="form-control"  placeholder="নাম">
                        <p v-show="errors.has('name')"  style="color:red">* {{ errors.first('name') }}</p>
                    </div>
                    <label class="col-sm-3 col-form-label">জন্ম তারিখ</label>
                    <div class="col-sm-3">
                        <input type="date" disabled v-model="user.birthday" class="form-control"  placeholder="জন্ম তারিখ">
                    </div>
                </div>
                <div  class="form-group row">
                    <label  class="col-sm-3 col-form-label">পিতা/স্বামীর নাম <span class="required">*</span></label>
                    <div class="col-sm-3">
                        <input name="fathers_or_husband_name" data-vv-as="Father/husband"  v-validate="'required'"   type="text"  v-model="application.fathers_or_husband_name" class="form-control">
                        <p v-show="errors.has('fathers_or_husband_name')"  style="color:red">* {{ errors.first('fathers_or_husband_name') }}</p>
                    </div>
                    <label class="col-sm-3 col-form-label">ঠিকানা <span class="required">*</span></label>
                    <div class="col-sm-3">
                        <input type="text" v-validate="'required'" name="Address" v-model="application.address" class="form-control">
                        <p v-show="errors.has('Address')"  style="color:red">* {{ errors.first('Address') }}</p>
                    </div>
                </div>
                <div  class="form-group row">
                    <label class="col-sm-3 col-form-label">লিজ <span class="required">*</span></label>
                    <div class="col-sm-3">
                        <select v-validate="'required'" data-vv-as="Market number" v-model="application.ward_no" name="ward_no" class="form-control">
                            <option value="">লিজ </option>
                            <option :value="ward.id" v-for="(ward,key) in wards" :key="key">{{ward.name}}</option>
                        </select>
                        <p v-show="errors.has('ward_no')"  style="color:red">* {{ errors.first('ward_no') }}</p>
                    </div>
                    <label  class="col-sm-3 col-form-label">কার্যক্রম শুরুর তারিখ <span class="required">*</span></label>
                    <div class="col-sm-3">
                        <input name="start_date" data-vv-as="Start date"  v-validate="'required'" type="date"  v-model="application.start_date" class="form-control">
                        <p v-show="errors.has('start_date')"  style="color:red">* {{ errors.first('start_date') }}</p>
                    </div>
                </div>
                <div  class="form-group row">
                    <label  class="col-sm-3 col-form-label">সালামী/ অগ্রীম</label>
                    <div class="col-sm-3">
                        <input  type="number"  v-model="application.advance" class="form-control">
                    </div>
                    <label class="col-sm-3 col-form-label">বকেয়া</label>
                    <div class="col-sm-3">
                        <input type="number"  v-model="application.due" class="form-control">
                    </div>
                </div>
                <div  class="form-group row">
                    <label  class="col-sm-3 col-form-label">বকেয়ার মাস ও বছর</label>
                    <div class="col-sm-3">
                        <input type="date"  v-model="application.due_date" class="form-control">
                    </div>
                    <label  class="col-sm-3 col-form-label">বাৎসরিক বিল <span class="required">*</span></label>
                    <div class="col-sm-3">
                        <input name="monthly_bill" data-vv-as="Monthly bill"  @change="changeYearBill()"  v-validate="'required'" type="number"  v-model="application.monthly_bill" class="form-control">
                        <p v-show="errors.has('monthly_bill')"  style="color:red">* {{ errors.first('monthly_bill') }}</p>
                    </div>
                </div>
                <div  class="form-group row">
                    <label class="col-sm-3 col-form-label">লিজ বছর <span class="required">*</span></label>
                    <div class="col-sm-3">
                        <input type="number" name="lease_year" @change="changeYear()" data-vv-as="Lease Year"  v-validate="'required'" v-model="application.lease_year" class="form-control">
                        <p v-show="errors.has('lease_year')"  style="color:red">* {{ errors.first('lease_year') }}</p>
                    </div>
                    <label  class="col-sm-3 col-form-label">মোট বিল <span class="required">*</span></label>
                    <div class="col-sm-3">
                        <input name="lease_amount" @change="changeTotal()" data-vv-as="Lease Amount"  v-validate="'required'"   type="number"  v-model="application.lease_amount" class="form-control">
                        <p v-show="errors.has('lease_amount')"  style="color:red">* {{ errors.first('lease_amount') }}</p>
                    </div>
                </div>
                <div  class="form-group row">
                    <label class="col-sm-3 col-form-label">অন্যান্য আদায়</label>
                    <div class="col-sm-3">
                        <input type="number"  v-model="application.other_amount" class="form-control">
                    </div>
                </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-12">
                    <input type="submit" value="submit" v-if="!addApplicationLoader"  class="btn btn-primary pull-right">
                    <button v-if="! addApplicationLoader" @click.prevent="close" class="btn btn-success pull-right" style="margin-right:5px;">Close</button>
                    <button v-if="addApplicationLoader" class="btn btn-primary pull-right" type="button" disabled>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Submitting...
                    </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import Vue from 'vue'
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate)

import { ADD_APPLICATION} from "@/store/action.type"
export default {
    data(){
        return{
            question:0,
            question2:0,
            servererrors:{},
            addApplicationLoader:false,
            index:'',
            largeModal:false,
            holdings:[],
            diameter_list:[],
            check:false,
            user:{
                id:'',
                name:'',
                nid:'',
                mobile_number:'',
                birthday:''
            },
            application_fee:0,
            application:{
                name:'',
                address:'',
                fathers_or_husband_name:'',
                road_name:'',
                mothers_name:'',
                moholla_name:'',
                home_type:'',
                ward_no:'',
                imarat_number:'',
                family_number:'',
                water_line_change_reason:'',
                previous_water_line_number:'',
                previous_bill_due:'',
                paura_tax:'',
                tax_pay_date:'',
                applicant_picture:'',
                applicant_sign:'',
                word_counsil_comment:'',
                fee:0,
                monthly_bill:0,
                adjustment:0,
                holding_id:'',
                service_id:'',
                adjustment_type:'',
                holding_name:'',
                type:'new-other-leadge',
                file:'',
                not_edit_file:11,
                other_amount:null,
                due_date:null,
                due:null,
                advance:null,
                volume:null,
                start_date:null,
                volume:null,
                lease_amount:0,
                lease_year:1

            },
            adjustment_type:'',
            service_list:[],
            select_dia:''
        }
    },
    methods:{

        getHoldingName(){
            var self = this
            this.holdings.forEach(element=>{
                if(element.id == self.application.holding_id){
                    self.application.holding_name = element.name ? element.name : element.bn_name
                }
            })
        },

        errorClear(fields)
        {
            delete this.servererrors[fields];
        },
        close(){
            this.largeModal = false
        },
        changeYearBill(){
            this.application.lease_amount = parseInt(this.application.monthly_bill)*parseInt(this.application.lease_year)
        },
        changeYear(){
            this.application.lease_amount = parseInt(this.application.monthly_bill)*parseInt(this.application.lease_year)
        },
        changeTotal(){
            this.application.monthly_bill = parseInt(this.application.lease_amount)/parseInt(this.application.lease_year)
        },
        addApplication () {
            if(this.$user.type !=1){
                this.application.file = true
                this.application.not_edit_file = 10
            }
            this.check = true
            this.$validator.validateAll().then( result =>{
                if(result){
                    this.check = false
                    this.application.user_id = this.user.id;
                    var data = this.application
                    this.addApplicationLoader = true;
                    this.$store.dispatch('ADD_APPLICATION',data)
                    .then(response=>{
                        this.addApplicationLoader = false;
                        this.largeModal = false
                    })
                    .catch(error=>{
                        this.addApplicationLoader=false;
                        this.servererrors = error.response.data.errors;
                    });
                }

            })

        },
        openModal(user_data){
            this.question = 0
            this.application.fee = 0
            this.application.monthly_bill = 0
            this.application.adjustment = 0
            this.application.holding_id = ''
            this.application.service_id = ''
            this.application.ward_no = ''
            this.application.other_amount = null
            this.application.due_date = null
            this.application.due = null
            this.application.advance = null
            this.application.volume = null
            this.application.start_date = null
            this.application.volume = null
            this.application.fathers_or_husband_name = ''
            this.application.name = null
            this.application.address = ''
            this.application.adjustment_type = ''
            this.application.holding_name = ''
            this.adjustment_type = ''
            this.lease_amount=0
            this.check = false
            this.application.file = ''
            this.index = ''
            this.largeModal = true
            this.user = user_data.user
            this.holdings = user_data.holding
            this.diameter_list = user_data.project
            this.lease_year = ''
        },
    },
    computed:{
        ...mapGetters(["wards"])
    },

}
</script>

<style scoped>
    /* width */
    ::-webkit-scrollbar {
        width: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #888;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
.custom_modal_body{
    overflow: auto;
    min-height: 380px;
    overflow-x: hidden;
}
.modal-window{
        position: fixed;
        z-index: 99999;
        padding-top: 50px;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .modal-content{
        position: fixed;
        z-index: 144;
        padding-top: 15px;
        left: 15%;
        top: 10%;
        width:70%;
         height:80%;
        overflow: auto;
        background-color:#fff;
    }
    .pt-2{
        padding-top:20px !important;
    }
    .required{
        color: red;
    }
</style>
